/**
 * Returns the base URL by combining the window's origin and the app's subdirectory.
 * @returns {string} The base URL.
 */
export const getBaseUrl = () => `${window?.location?.origin}/${window?.AppData?.subdirectory}`;

/**
 * Returns the API URL by appending '/api' to the base URL.
 * @returns {string} The API URL.
 */
export const getApiUrl = () => `${getBaseUrl()}/api`;
